import { api } from "@/builders/axios";
import { FilterParams } from "@/builders/types/filter-params";
import { chapter } from "./chapter";
import { id } from "./id";

function get(params?: FilterParams) {
  return api.get<{
    count: number;
    next: string;
    previous: string;
    results: Array<{
      course: number;
      assessment: number;
    }>;
  }>("courses/module", {
    params,
  });
}

function post(data: { course: number; assessment: number }) {
  return api.post("courses/module", data);
}

export const modules = {
  get,
  post,
  id,
  chapter,
};
